export function getReservationDisplayId(groupId: string) {
  return groupId.split("-")[0] ?? "";
}
